import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { DialogSubscribeToDirectComponent } from '@app/modules/direct/dialogs/dialog-subscribe-to-direct/dialog-subscribe-to-direct.component';
import { DirectPlan } from '@app/modules/direct/models/direct-subscription.interface';
import { DirectDashboardService } from '@app/modules/direct/services/direct-dashboard.service';
import { DirectSubscriptionService } from '@app/modules/direct/services/direct-subscription.service';

@Component({
  selector: 'sbnb-direct-overview-setup-guide',
  templateUrl: './direct-overview-setup-guide.component.html',
})
export class DirectOverviewSetupGuideComponent {
  publishSiteStep = false;

  constructor(
    public directDashboardService: DirectDashboardService,
    private directSubscription: DirectSubscriptionService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  addSite() {
    this.router.navigate(['/direct/sites/new']);
  }

  addPayoutMethod() {
    const subscriptionStatus = this.directSubscription.getCurrentSubscriptionStatus();

    if (subscriptionStatus.plan === DirectPlan.Premium) {
      this.router.navigate(['/direct/payouts/new/adyen']);
    } else {
      this.router.navigate(['/direct/payouts/new/stripe-oauth']);
    }
  }

  setupTaxes() {
    this.router.navigate(['/settings/taxes/name']);
  }

  activateDirect() {
    this.dialog.open(DialogSubscribeToDirectComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      disableClose: true,
      data: {},
    });
  }

  publishSite() {
    this.directDashboardService.publishSite();
  }

  selectProperties() {
    this.directDashboardService.selectProperties();
  }
}
